import IVscCommunityMapInfo from "../../../visualizers/IVscCommunityMapInfo";
import {IModel} from "../../../kova/slsordClient";
import {IConfiguratorProxy, IOptionItemChoice} from "@bimaire/optionslib";
import CameraAdminInfo from "../../admin/CameraAdmin";
import ViewpointAdminInfo from "../../admin/ViewpointAdminInfo";
import {useVisualizerSession} from "../../visualizer/VscVisualizerSession";
import {IModelConfig, IViewCamera, IViewpoint} from "../../../data/IViewpoint";


interface IPlanAdminInfoProps {
    mapInfo: IVscCommunityMapInfo,
    modelConfig: IModelConfig,
    model: IModel,
    configurator: IConfiguratorProxy
}

function getConfiguratorOption(menuId:string, choices: IOptionItemChoice[]) {
    const choice = choices.find(ch => ch.choice.items[0].item.id === menuId);
    let slsOrdValue = choice?.choice.items[1].item.id ?? "";
    const style = choice?.choice.items.find(itm => itm.level === "Style");
    const color = choice?.choice.items.find(itm => itm.level === "Color");
    if (style) {
        slsOrdValue += "_" + style?.item.id;
    }
    if (color) {
        slsOrdValue += "_" + color?.item.id;
    }
    return slsOrdValue;
}
const PlanAdminInfo: React.FC<IPlanAdminInfoProps> = (props) => {
    const {configurator, mapInfo, model, modelConfig} = props;
    const unrealLot = mapInfo.lots.find(lot => lot.lotId === modelConfig.lotId);
    const vscVisualizer = useVisualizerSession();
    const viewCamera = (cameraId:string) => {
        vscVisualizer.changeCamera(cameraId);
    }
    const viewViewpoint = (viewpoint:IViewpoint) => {
        vscVisualizer.changeCameraToViewpoint(viewpoint, modelConfig.lotId);
    }
    const planProps: Record<string, string[]> = {}

    const unrealVsErpProps: Record<string, string[]> = {
        "Plan": [unrealLot?.blueprintName ?? "", model.id, ""]

    };


    const unrealVsErpOptions: Record<string, string[]> = {};

    const choices = configurator.getChoices();


    for (const opt of unrealLot?.options ?? []) {

        const optionConfig = modelConfig.options.find(optcfg => typeof(optcfg) === 'string' ? (optcfg === opt.optionMenu) : (optcfg.id === opt.optionMenu));
        let optionConfigName = "";
        if (optionConfig) {
            if (typeof optionConfig === 'string') {
                optionConfigName = optionConfig;
            } else {
                optionConfigName = optionConfig.name;
            }
        }
        const slsOrdValue = getConfiguratorOption(opt.optionMenu, choices);
        unrealVsErpOptions[opt.optionMenu] = [
            opt.selectedValue.length > 0 ? opt.selectedValue : "-",
            slsOrdValue ?? "",
            optionConfigName

        ];
    }

    for (const cfgOption of modelConfig.options) {
        const optId = typeof cfgOption === 'string' ? cfgOption : cfgOption.id;
        const optName = typeof cfgOption === 'string' ? cfgOption : cfgOption.name;
        if (unrealVsErpOptions[optId] === undefined) {
            const slsOrdValue = getConfiguratorOption(optId, choices);

            unrealVsErpOptions[optId] = ["-", slsOrdValue, optName];
        }
    }

    const mergedErpProps = {...unrealVsErpProps, ...unrealVsErpOptions};
    const viewpointGroupDefinition = modelConfig.viewpointGroupDefinition;
    const lotCameras = mapInfo.cameras.filter(camera => modelConfig.lotId && camera.cameraId.startsWith(modelConfig.lotId));
    const allViews = modelConfig.views.flatMap(v => v.items);

    const enabledViewpoints: IViewCamera[] = allViews.filter(v => v.type === "viewpoint") as IViewCamera[];
    const enabledCameras : IViewCamera[] = (allViews.filter(v => v.type === "camera") as IViewCamera[])
        .map(c => ({...c, camera: `${modelConfig.lotId}-${c.camera}`}));
return <section>
    { unrealLot === undefined && <h2 style={{color:'red'}}>Lot {modelConfig.lotId} does not exist in Unreal!</h2>}

    <h3>Unreal vs ERP</h3>
    <table style={{border: "1px solid black"}}>
        <tr>
            <th>Property</th>
            <th>Unreal</th>
            <th>ERP</th>
            <th>Controller</th>
        </tr>

        { Object.keys(mergedErpProps).map(erpProp => <tr title={mergedErpProps[erpProp][2]} style={{
            border: "1px solid black",
            backgroundColor: mergedErpProps[erpProp][0] === mergedErpProps[erpProp][1] ? "lightgreen" : "inherit"
        }}>

            <td>{erpProp}</td>
            <td>{mergedErpProps[erpProp][0]}</td>
            <td>{mergedErpProps[erpProp][1]}</td>
            <td>{mergedErpProps[erpProp][2]}</td>

        </tr>)}
    </table>
    {lotCameras.length > 0 && <div>
    <h3>Cameras</h3>
    <CameraAdminInfo cameras={lotCameras} onViewCamera={viewCamera} enabledCameras={enabledCameras} />
    </div>}


    { viewpointGroupDefinition && viewpointGroupDefinition.Viewpoints.length > 0 && <div>
        <h3>Viewpoints</h3>

        <ViewpointAdminInfo viewpointGroup={viewpointGroupDefinition} onViewViewpoint={viewViewpoint} enabledViewpoints={enabledViewpoints}/>
    </div>
    }
</section>



}
export default PlanAdminInfo;